module.exports = __webpack_public_path__ + "img/gyant_brown_ba_detail_rsh3(1).fe410a5e.jpg";